// @flow

import React from 'react';
import { Elements } from 'react-stripe-elements';
import ChargeForm from 'containers/payer/charge-form';
import Layout from 'components/shared/layout';
import SectionHeader from 'components/shared/section-header';
import { Container, Logo, Wrapper } from './styles';

const CreditCardForm = ({
  handlePlaidSuccess,
  business,
  handleClick,
  logoUrl,
  pendingBankAccountAttributes,
  showNewCreditCardForm,
  toggleCreditCardForm,
}: any) => {
  const showForm = true;

  return (
    <Container>
      <Layout>{logoUrl && <Logo src={logoUrl} alt="logo" />}</Layout>
      <Wrapper>
        <SectionHeader
          headline={`Enter your payment method for ${business.attributes.name}`}
          textAlign="center"
        />
        {showForm && (
          <Elements>
            <ChargeForm
              handleClick={handleClick}
              handlePlaidSuccess={handlePlaidSuccess}
              pendingBankAccountAttributes={pendingBankAccountAttributes}
              showNewCreditCardForm={showNewCreditCardForm}
              toggleCreditCardForm={toggleCreditCardForm}
              initialValues={{
                autopayEnabled: true,
              }}
            />
          </Elements>
        )}
      </Wrapper>
    </Container>
  );
};

export default CreditCardForm;



// WEBPACK FOOTER //
// ./src/components/payer/credit-card-form/index.js